import type { BankAccount, BankConnection } from "@/apis/gql/types";
import { gql, useQuery } from "@apollo/client";

export type GetAllBankAccountsBankAccount = Pick<
  BankAccount,
  | "bankAccountId"
  | "name"
  | "accountNumber"
  | "type"
  | "iban"
  | "defaultAccount"
  | "currency"
  | "finapiAccountId"
> & {
  bankConnection?: Pick<
    BankConnection,
    "bankConnectionId" | "metadata" | "bankName" | "txnImportEnabled"
  >;
};

export type GetAllBankAccountsResponse = {
  bankAccounts: GetAllBankAccountsBankAccount[];
};

export type BankAccountQueryParams = {
  fetchPolicy?: "cache-first" | "cache-and-network" | "network-only";
};

export const useGetAllBankAccounts = (params?: BankAccountQueryParams) => {
  const { data, loading, error, refetch } =
    useQuery<GetAllBankAccountsResponse>(BANK_ACCOUNTS_QUERY, {
      fetchPolicy: params?.fetchPolicy,
    });
  return { bankAccounts: data?.bankAccounts ?? [], loading, error, refetch };
};

export const BANK_ACCOUNTS_QUERY = gql`
  query GetAllBankAccounts {
    bankAccounts {
      bankAccountId
      name
      accountNumber
      type
      iban
      defaultAccount
      currency
      finapiAccountId
      journalAccounts {
        journalAccountId
      }
      bankConnection {
        txnImportEnabled
        bankConnectionId
        bankName
        metadata {
          id
          bank {
            name
            logo {
              url
            }
            icon {
              url
            }
            bankGroup {
              name
              icon {
                url
              }
              logo {
                url
              }
            }
          }
        }
      }
    }
  }
`;
